"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const TabsSet_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/TabsSet.vue"));
const Tab_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/Tab.vue"));
const HeatmapChart_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/render/components/HeatmapChart.vue"));
const Loader_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/UI/Loader.vue"));
const PlusMinus_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/UI/PlusMinus.vue"));
const lucide_vue_next_1 = require("lucide-vue-next");
const debounce_1 = require("@common/tsutils/debounce");
let Viz = class Viz extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.is_heatmap_ready = false;
        this.zoomLevel = 1;
        this.zoomUpdate = false;
        this.groupsShouldBeRebuild = false;
        this.legendStages = [
            'Not Available',
            'Not Detected',
            'Very Low',
            'Low',
            'Medium',
            'High',
            'Very High',
        ];
    }
    minusClick() {
        this.zoomLevel = -0.5;
        this.zoomUpdate = true;
    }
    plusClick() {
        this.zoomLevel = 0.5;
        this.zoomUpdate = true;
    }
    onChangeFocus() {
        // this.onHeatmapChange();
    }
    onHeatmapChange() {
        this.groupsShouldBeRebuild = false;
        this.is_heatmap_ready = false;
        this.onHeatmapChange2();
    }
    onHeatmapChangeWithRebuild() {
        this.groupsShouldBeRebuild = true;
        this.is_heatmap_ready = false;
        this.onHeatmapChange2();
    }
    onChangeGroups(instance) {
        if (instance && instance.direction == 'manual') {
            return;
        }
        this.onHeatmapChangeWithRebuild();
    }
    onChangeOrder(instance) {
        if (!instance || instance.direction == 'manual') {
            return;
        }
        this.onHeatmapChange();
    }
    onHeatmapChange2() {
        if (this.groupsShouldBeRebuild) {
            this.heatmap.buildGroups();
        }
        else {
            this.heatmap.orderSamplesInFinalGroups();
        }
        this.is_heatmap_ready = this.heatmap.selectedSamples.length > 0;
    }
    get stdlegend() {
        return this.heatmap.selectedElement !== 'hlt';
    }
    resetHeatmapPosition() {
        this.heatmap.modifiedZoom = false;
        this.zoomLevel = 0.5;
    }
    onZoomUpdated() {
        this.zoomUpdate = false;
    }
    onHeatmapRefreshed() {
        this.$emit('onheatmaprefreshed');
    }
    onNewActive() {
        this.$emit('onitemactive');
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Viz.prototype, "heatmap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Viz.prototype, "fsactive", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Viz.prototype, "focuslevel", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('heatmap.selectedFocus')
], Viz.prototype, "onChangeFocus", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('heatmap.selectedElement')
], Viz.prototype, "onHeatmapChange", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('heatmap.optionOrientation'),
    (0, vue_property_decorator_1.Watch)('heatmap.selectedSamples.length')
], Viz.prototype, "onHeatmapChangeWithRebuild", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('heatmap.groupConfigInstance1', { deep: true }),
    (0, vue_property_decorator_1.Watch)('heatmap.groupConfigInstance2', { deep: true })
], Viz.prototype, "onChangeGroups", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('heatmap.orderConfigInstance', { deep: true })
], Viz.prototype, "onChangeOrder", null);
__decorate([
    (0, debounce_1.Debounce)(200) // TODO
], Viz.prototype, "onHeatmapChange2", null);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Viz.prototype, "config", void 0);
Viz = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { TabsSet: TabsSet_vue_1.default, Tab: Tab_vue_1.default, Crosshair: lucide_vue_next_1.Crosshair, HelpCircle: lucide_vue_next_1.HelpCircle, HeatmapChart: HeatmapChart_vue_1.default, Loader: Loader_vue_1.default, PlusMinus: PlusMinus_vue_1.default },
    })
], Viz);
exports.default = Viz;
